import { MapTypeControlOptions, ControlPosition } from '@agm/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { FarmoutService } from 'src/app/service/farmout-service/farmout.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { lyftTrip } from './lyft';

@Component({
  selector: 'app-lyft-details-modal',
  templateUrl: './lyft-details-modal.component.html',
  styleUrls: ['./lyft-details-modal.component.css']
})
export class LyftDetailsModalComponent implements OnInit {
  @Input() data;
  @Output() onClose = new EventEmitter<any>();
  farmoutDetail;
  driverTip;
  farmoutReceipt;
  isDrawRoute = true;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  pickupURL = null;
  dropOffURL = null;
  cancelURL = null;


  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  driverLocation;
  user;

  isFarmoutIntegration = false;
  messages=[];
  newMessage: string = '';
  driverList = [];
  countdown: number = 20;
  private timerSubscription: any;
  showMessage:boolean=false
  platform = '';


  constructor(
    private assignTripService: AssigTripsService,
    private sharedDataService: SharedDataService,
    private farmoutService: FarmoutService,
    private authService: AuthService
  ) { }


  ngOnInit() {
    this.platform = this.data.farmout && this.data.farmout.platform ? this.data.farmout.platform : '';
    console.log('Farmout Modal Data:', this.data);
    this.getUser();
    // this.startTimer();

    if (this.data.farmout) {
      this.checkTripStatus()
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          if (this.user.hasOwnProperty('isFarmout')) {
            this.isFarmoutIntegration = this.user.isFarmout
          }
          this.details();
        }
      });
  }

  closeDetailModal(evt) {
    this.onClose.emit(evt);
  }

  details_old() {
    const companyId = this.user.company ? this.user.company._id : this.user._id
    this.farmoutService
      .rideDetailsRequest({ ...this.data.farmout, company: companyId, platform: 'lyft'})
      .subscribe(async(data) => {
        if (data) {
          this.farmoutDetail = data;
          this.origin = {
            lat: this.farmoutDetail.pickup.latitude,
            lng: this.farmoutDetail.pickup.longitude
          };
          this.destination = {
            lat: this.farmoutDetail.destination.latitude,
            lng: this.farmoutDetail.destination.longitude
          };
          this.pickupURL = await this.loadStaticMap(this.farmoutDetail.waypoints[0].latitude, this.farmoutDetail.waypoints[0].longitude);
          this.dropOffURL = await this.loadStaticMap(this.farmoutDetail.waypoints[1].latitude, this.farmoutDetail.waypoints[1].longitude);

          if (this.farmoutDetail.location) {
            this.driverLocation = {
              latitude: this.farmoutDetail.location.latitude,
              longitude: this.farmoutDetail.location.longitude
            }
          } else if (this.farmoutDetail.trip_end_location) {
            this.driverLocation = {
              latitude: this.farmoutDetail.trip_end_location.latitude,
              longitude: this.farmoutDetail.trip_end_location.longitude
            }
          }
          this.getMessages();
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
    // this.assignTripService
    //   .farmoutRideReceiptRequest(this.data.farmout)
    //   .subscribe((data) => {
    //     if (data) {
    //       console.log("farmout Receipt Data", data);
    //     }
    //   });
  }

  async details() {
    // const data = lyftTrip;
    // if (data) {
    //   this.farmoutDetail = data;
    //   this.origin = {
    //     lat: this.farmoutDetail.origin.lat,
    //     lng: this.farmoutDetail.origin.lng
    //   };
    //   this.destination = {
    //     lat: this.farmoutDetail.destination.lat,
    //     lng: this.farmoutDetail.destination.lng
    //   };
    //   this.pickupURL = await this.loadStaticMap(this.farmoutDetail.origin.lat, this.farmoutDetail.origin.lng);
    //   this.dropOffURL = await this.loadStaticMap(this.farmoutDetail.destination.lat, this.farmoutDetail.destination.lng);

    //   if (this.farmoutDetail.location) {
    //     this.driverLocation = {
    //       latitude: this.farmoutDetail.location.latitude,
    //       longitude: this.farmoutDetail.location.longitude
    //     }
    //   } else if (this.farmoutDetail.trip_end_location) {
    //     this.driverLocation = {
    //       latitude: this.farmoutDetail.trip_end_location.latitude,
    //       longitude: this.farmoutDetail.trip_end_location.longitude
    //     }
    //   }
    // }
    // return;
    const companyId = this.user.company ? this.user.company._id : this.user._id
    this.farmoutService
      .rideDetailsRequest({ ...this.data.farmout, company: companyId, platform: this.platform })
      .subscribe(async (data) => {
        if (data) {
          this.farmoutDetail = data;
          this.origin = {
            lat: this.farmoutDetail.origin.lat,
            lng: this.farmoutDetail.origin.lng
          };
          this.destination = {
            lat: this.farmoutDetail.destination.lat,
            lng: this.farmoutDetail.destination.lng
          };
          // this.pickupURL = await this.loadStaticMap(this.farmoutDetail.waypoints[0].latitude, this.farmoutDetail.waypoints[0].longitude);
          // this.dropOffURL = await this.loadStaticMap(this.farmoutDetail.waypoints[1].latitude, this.farmoutDetail.waypoints[1].longitude);

          // if (this.farmoutDetail.location) {
          //   this.driverLocation = {
          //     latitude: this.farmoutDetail.location.latitude,
          //     longitude: this.farmoutDetail.location.longitude
          //   }
          // } else if (this.farmoutDetail.trip_end_location) {
          //   this.driverLocation = {
          //     latitude: this.farmoutDetail.trip_end_location.latitude,
          //     longitude: this.farmoutDetail.trip_end_location.longitude
          //   }
          // }
          // this.getMessages();
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  sendTip() {
    if (!this.driverTip) return;
    const companyId = this.user.company ? this.user.company._id : this.user._id

    const payload = {
      "request_id": this.farmoutDetail.request_id,
      "tip_amount": this.driverTip,
      "company": companyId
    }
    this.farmoutService
      .tipRequest(payload)
      .subscribe(data => {
        if (data) {
          this.farmoutDetail.can_tip = false;
          this.details();
        }
      }, err => {
        console.log(err);
        sweetAlert('Error', err, 'warning', 'OK');
      });

  }

  getReceipt() {
    const companyId = this.user.company ? this.user.company._id : this.user._id
    this.farmoutService
      .rideReceiptRequest(this.farmoutDetail.ride_id, { company: companyId, platform: this.platform })
      .subscribe(data => {
        if (data) {
          this.farmoutReceipt = data;
        }
      }, err => {
        console.log(err);
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }
  convertTime(time){
    if(!time) return 'N/A';
    return moment(time).tz(this.user.timeZone).format("MM/DD/YY HHmm")
  }

  ngOnDestroy(): void {
  }

  loadStaticMap = async (lat, lng) => {
    let mapKey = '';
    const res = await this.authService.getGoogleKeys().toPromise();
    if (res && res.key) {
      console.log('Load static map API key:');
      mapKey = res.key;
    } else {
      console.error('Error load static map API key');
    }
    let url = 'https://maps.googleapis.com/maps/api/staticmap?center='
      + lat + ',' + lng + '&zoom=18&size=500x500&maptype=satellite&markers=color:red|' + lat
      + ',' + lng + '&key=' + mapKey;

    return url;
  }

  startTimer(): void {
    this.timerSubscription = setInterval(() => {
      this.countdown--

      if (this.countdown <= 0) {
        this.countdown = 20;
        this.getMessages();
      }
    }, 1000);
  }

  getMessages() {
    if (this.data && this.data.farmout) {
      this.farmoutService.getMessages(this.data.farmout.requestId).subscribe(res => {
        this.messages = res.results || []
      });
    }

  }

  sendMessage() {
    const myUser = this.user && this.user.company ? this.user.company : this.user;

    if (!this.newMessage || !this.newMessage.trim()) {
      return;
    }

    const payload = {
      requestId: this.data.farmout.requestId,
      message: this.newMessage.trim(),
      company: myUser._id
    };

    this.farmoutService.sendMessage(payload).subscribe(res => {
      console.log(res);

      // clear textarea after send
      this.newMessage = '';
    });
  }

  checkTripStatus(): void {
    const validStatuses = ['processing','scheduled', 'arriving', 'in_progress', 'accepted', 'completed'];
    this.showMessage = validStatuses.includes(this.data.farmout.status);
  }

  shouldShowDateDivider(index: number): boolean {
    if (index === 0) return true;
    const prev = new Date(this.messages[index - 1].createdAt);
    const curr = new Date(this.messages[index].createdAt);
    return prev.toDateString() !== curr.toDateString();
  }

  formatDateDivider(date: string) {
    const msgDate = new Date(date);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (msgDate.toDateString() === today.toDateString()) return 'Today';
    if (msgDate.toDateString() === yesterday.toDateString()) return 'Yesterday';
    return msgDate.toLocaleDateString();  // Return the actual date
  }
}
